import { useState } from 'react';
import AdminSidebar from '@/components/layout/AdminSidebar';
import AdminNotificationBell from '@/components/admin/AdminNotificationBell';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true); // Default collapsed

  return (
    <div className="flex min-h-screen bg-slate-50">
      <AdminSidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div className={`flex-1 flex flex-col transition-all duration-300 ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
        {/* Top Header with Notifications */}
        <header className="sticky top-0 z-30 bg-white border-b border-slate-200 px-4 h-16 flex items-center justify-between">
          <div className="flex items-center">
            <Button
              variant="ghost"
              size="icon"
              className="lg:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <Menu className="w-6 h-6" />
            </Button>
            <h1 className="ml-2 lg:ml-0 text-lg font-outfit font-semibold text-slate-900">Admin Panel</h1>
          </div>
          
          {/* Notification Bell */}
          <div className="flex items-center gap-2">
            <AdminNotificationBell />
          </div>
        </header>
        
        <main className="flex-1 p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;